var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"date-selection-container"},[_c('slick',{ref:"slick1",attrs:{"options":_vm.dateSelectionSlider}},_vm._l((_vm.dates),function(dateLoop,loop){return _c('div',{key:loop},[_c('div',{staticClass:"date-slider-box",class:_vm.selectedDate == dateLoop
            ? 'active cursor-pointer'
            : _vm.allowPastBooking == 'Y'
            ? 'cursor-pointer'
            : new Date(_vm.currentDate) > new Date(dateLoop)
            ? 'cursor-pointer'
            : 'cursor-pointer',on:{"click":function($event){return _vm.onSelecteDate(dateLoop)}}},[_c('div',{staticClass:"text-center"},[_c('span',[_vm._v(_vm._s(dateLoop))]),_vm._v(" "),_c('div',{staticClass:"lh-1",staticStyle:{"font-size":"80%"}},[_vm._v("\n            "+_vm._s(_vm._f("dayparse")(dateLoop))+"\n          ")])])])])}),0)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7c3b4ae1","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Partials/posDateSlider.vue
// module id = null
// module chunks = 